import { render, staticRenderFns } from "./BookingFormContainer.vue?vue&type=template&id=572becd2&scoped=true"
import script from "./BookingFormContainer.vue?vue&type=script&lang=js"
export * from "./BookingFormContainer.vue?vue&type=script&lang=js"
import style0 from "./BookingFormContainer.vue?vue&type=style&index=0&id=572becd2&prod&lang=scss"
import style1 from "./BookingFormContainer.vue?vue&type=style&index=1&id=572becd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572becd2",
  null
  
)

export default component.exports